import { gql, useMutation } from '@apollo/client';

import { GET_VACANCIES } from './get-vacancies.hook';
import { GET_VACANCY_BY_ID } from './get-vacancy-by-id.hook';

export const UPDATE_VACANCY_BY_ID = gql`
  mutation updateVacancyById($payload: UpdateVacancyPatternInput!, $vacancyId: ObjectId!) {
    updateVacancyById(payload: $payload, vacancyId: $vacancyId) {
      _id
    }
  }
`;

export const useUpdateVacancyById = ({ onSuccess }: { onSuccess: () => void }) => {
  const [updateVacancy, { loading }] = useMutation(UPDATE_VACANCY_BY_ID, {
    refetchQueries: [GET_VACANCY_BY_ID, GET_VACANCIES],
    onCompleted: onSuccess,
  });

  return { updateVacancy, loading };
};
